<template>
  <div class="live-data-card" :class="{'mobile': isMobileDevice}">
    <div class="card-name">
      {{label}}
    </div>
    <span class="card-value">
      {{value}}
    </span>
    <span class="card-unit">
      {{unit}}
    </span>
  </div>
</template>

<script>
  import { createNamespacedHelpers } from "vuex";
  import {DeviceInfoMixin} from "@/mixins";
  const {
    mapState: mapStateOfEnterpriseVesselView,
    mapActions: mapActionsOfEnterpriseVesselView,
  } = createNamespacedHelpers("enterpriseVesselView");

  export default {
    name: "VesselLiveDataCard",
    data() {
      return {
        dataReady: false,
        deviceInfo: null
      };
    },
    mixins: [DeviceInfoMixin],
    props: {
      channelId: {type: String},
      kind: {type: String},
      label: {type: String},
      originNumber: {type: Number},
      vesselId: {type: String},
    },
    computed: {
      ...mapStateOfEnterpriseVesselView({
        kindOriginVersionMap: state => state.kindOriginVersionMap,
        vesselLiveData: state => state.vesselLiveData,
        liveDataValueMap: state => state.liveDataValueMap,
        channelUnitMap: state => state.channelUnitMap
      }),
      value() {
        if (this.dataReady) {
          return this.liveDataValueMap[this.versionName + "/" + this.channelId]
        } else {
          return null
        }
      },
      versionName (){
        if (this.dataReady) {
          return this.kindOriginVersionMap[this.kind][this.originNumber]["version_name"]
        } else {
          return null
        }
      },
      unit() {
        if (this.dataReady) {
          let versionId = this.kindOriginVersionMap[this.kind][this.originNumber]["version_id"]
          return  this.channelUnitMap[versionId][this.channelId]
        } else {
          return null
        }
      },
      isMobileDevice() {
        if (this.deviceInfo) {
          return this.deviceInfo.deviceType == "iPhone"
        } else {
          return false
        }
      }
    },
    async created() {
      this.deviceInfo = this.getDeviceInfo()
      if (!Object.prototype.hasOwnProperty.call(this.kindOriginVersionMap, this.kind)) {
        let payload = {
          kind: this.kind,
          vesselId: this.vesselId,
          origin: this.originNumber,
        }
        let version = await this.getVersion(payload)
        let updateVersionObject = {
          kind: this.kind,
          origin: this.originNumber,
          version: version.data
        }
        this.updateVersionMap(updateVersionObject)
      }

      let versionId = this.kindOriginVersionMap[this.kind][this.originNumber]["version_id"]
      if (!Object.prototype.hasOwnProperty.call(this.channelUnitMap, versionId) || !Object.prototype.hasOwnProperty.call(this.channelUnitMap[versionId], this.channelId)) {
        let payload = {
          versionId: this.kindOriginVersionMap[this.kind][this.originNumber]["version_id"],
          vesselId: this.vesselId,
          keyword: this.channelId
        }
        let unitObject = await this.getChannelUnit(payload)
        let updateUnitObject = {
          versionId: this.kindOriginVersionMap[this.kind][this.originNumber]["version_id"],
          channelId: this.channelId,
          unit: unitObject.data.channels[0].unit
        }
        this.updateChannelUnitMap(updateUnitObject)
      }

      let subscribeList = []
      subscribeList.push(
        {
          channelId: this.channelId,
          versionName: this.kindOriginVersionMap[this.kind][this.originNumber]["version_name"],
          vesselId: this.vesselId,
          kind: this.kind,
        }
      )
      this.subscribeChannelDataFirestore(subscribeList)

      this.dataReady = true
    },
    methods: {
      ...mapActionsOfEnterpriseVesselView(
        ["getVersion", "subscribeChannelDataFirestore",
        "unsubscribeChannelDataFirestore", "updateVersionMap", "getChannelUnit", "updateChannelUnitMap"]
      ),
      
    },
    beforeDestroy() {
      this.unsubscribeChannelDataFirestore()
    }
  };
</script>

<style lang="scss" scoped>
  .live-data-card {
    font-size: 12px;
    background: #3D4656;
    border-radius: 5px;
    height: 100px;
    padding: 12px 10px;
    color: #f2f2f2;
    margin: 5px;
    .card-name {
      font-size: 12px;
    }
    .card-value {
      font-size: 18px;
    }
    .card-unit {
      font-size: 12px;
    }
  }
</style>
